import React, { PureComponent, Fragment } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Datepicker } from 'modules/shared'

class PendenciasForm extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            modo: 'id'
        }
    }

    changeMode(event) {
        this.setState({ modo: event.currentTarget.modo.value })
    }

    render() {
        const { handleSubmit, submitting } = this.props
        const DatePickerInput = ({ input, resetKey }) => <Datepicker key={resetKey} defaultDate={input.value} onChange={dates => input.onChange(dates) } />
        
        return (

            <form onSubmit={handleSubmit} onChange={event => this.changeMode(event)}>

                <div className="row mt-3">   

                    <div className="col col-sm-8 offset-sm-2 col-md-6 offset-md-3 mt-2">
                        <label htmlFor="" className="">Modo de consulta: </label>
                        <div className="form-check">
                            <Field component="input" className="form-check-input" type="radio" name="modo" id="modo1" value="id" />
                            <label className="form-check-label" htmlFor="modo1">ID</label>
                        </div>
                        <div className="form-check">
                            <Field component="input" className="form-check-input" type="radio" name="modo" id="modo2" value="data" />
                            <label className="form-check-label" htmlFor="modo2">Período</label>
                        </div>

                        {this.state.modo && this.state.modo === 'id' &&
                        <div className="form-group mt-2">
                            <label htmlFor="formControlRange">ID Docsystem:</label>
                            <Field component="input" name="id" type="text" className="form-control" id="formControlRange" placeholder="Informe o ID" />
                        </div>}

                        {this.state.modo && this.state.modo === 'data' && 
                            <Fragment>
                                <div className="form-group mt-3">
                                    <label htmlFor="periodo">Período:</label>
                                    <Field component={DatePickerInput} name="periodo" className="form-control" id="periodo" placeholder="Selecione o período." />
                                </div>
                                <label>Filtrar por: </label><br />
                                <div className="form-check form-check-inline">
                                    <Field component="input" className="form-check-input" type="radio" name="periodo_filter" id="periodo_filter1" value="vencto" />
                                    <label className="form-check-label" htmlFor="periodo_filter1">Data de vencimento</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Field component="input" className="form-check-input" type="radio" name="periodo_filter" id="periodo_filter2" value="validacao" />
                                    <label className="form-check-label" htmlFor="periodo_filter2">Data de validação</label>
                                </div>
                                <br/><label className="mt-2">Exibir: </label><br />
                                <div className="form-check form-check-inline">
                                    <Field component="input" className="form-check-input" type="radio" name="exibition" id="exibition1" value="pendencias" />
                                    <label className="form-check-label" htmlFor="exibition1">Apenas pendências</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <Field component="input" className="form-check-input" type="radio" name="exibition" id="exibition2" value="tudo" />
                                    <label className="form-check-label" htmlFor="exibition2">Tudo</label>
                                </div>
                            </Fragment>
                        }   
                        <br />
                        <button type="submit" disabled={submitting} className="btn btn-primary btn-sm mt-4">
                            {submitting ? <div><i className="fas fa-spinner fa-spin fa-fw"></i> Enviando...</div> : 'Enviar'}
                        </button>

                    </div>

                </div>

            </form>
        )
    }
}

export default reduxForm({ form: 'pendencias_docsystem' })(PendenciasForm)